import React, {useContext} from "react";
import {Row} from "react-bootstrap";

import Product from "./product";
import Headline from "./common/headline";

import {AppContext} from "../App";

export default function Products() {

    const { data, setData } = useContext(AppContext);
    const { challenges, steps, products } = data;

    const toggleProducts = product => {
        let newProducts = products;
        product.selected = !product.selected;
        setData({
            products: newProducts,
            ...data
        })
    }

    const challengesSelected = challenges
        .filter(challenge => challenge.selected)
        .map(challenge => challenge.id);

    const selectedStepId = steps.find(step => step.selected)?.id;

    const productsRender = products
        .map(product => {
            const {challengesIDs, stepIDs} = product;

            if (!challengesSelected.length) {
                return product;
            }

            if (challengesIDs.some(challengeID => challengesSelected.includes(challengeID)) &&
                (!selectedStepId || stepIDs.includes(selectedStepId))) {
                product.disabled = false;
            } else {
                product.disabled = true;
                product.selected = false;
            }

            return product;
        })
        .map((product) =>  {
            return <Product product={product} toggleProducts={toggleProducts} key={product.id}/>
        });


    return (
        <div className="product-solutions">
            <Headline counter={3} title={'Select product groups'} />
            <Row>
                {productsRender}
            </Row>
        </div>
    );
}
